module.exports = __webpack_public_path__ + "img/grow_milk.a41bd181.svg";